"use client";

import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
import { useEffect } from "react";
import { useMarketingConsent } from "@/lib/consent";
import { GOOGLE_ADS_ID, isGoogleAdsConfigured } from "@/lib/google-ads/gtag";

/**
 * Google Ads gtag.js loader with Consent Mode v2
 *
 * Always loads gtag.js but respects consent state:
 * - Default: all ad consent denied (cookieless pings enable conversion modeling)
 * - On marketing consent: updates to granted (full cookie-based tracking)
 *
 * This enables Google's conversion modeling (~70% recovery rate)
 * for conversions from users who don't give marketing consent.
 */
export function GoogleAdsTag() {
  const $ = _c(4);
  const hasMarketingConsent = useMarketingConsent();
  let t0;
  let t1;
  if ($[0] !== hasMarketingConsent) {
    t0 = () => {
      if (typeof window === "undefined" || !window.gtag) {
        return;
      }
      const state = hasMarketingConsent ? "granted" : "denied";
      window.gtag("consent", "update", {
        ad_storage: state,
        ad_user_data: state,
        ad_personalization: state
      });
    };
    t1 = [hasMarketingConsent];
    $[0] = hasMarketingConsent;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  if (!isGoogleAdsConfigured()) {
    return null;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <><Script id="google-ads-init" strategy="afterInteractive">{`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('consent', 'default', {
            'ad_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied',
            'analytics_storage': 'denied'
          });
          gtag('js', new Date());
          gtag('config', '${GOOGLE_ADS_ID}');
        `}</Script><Script src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`} strategy="afterInteractive" /></>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}